import React from "react";
import { formatDate } from "../../helpers/utilities";

const OrderHistoryList = ({ orders, viewType }) => {
  return viewType === "list" ? (
    <div className="order-history-results-list">
      {orders.map((order) => {
        return (
          <div key={order.deliveryId} className="order-history-result-card row">
            <div className="col-md-4">
              <span className="text-2" style={{ fontWeight: "700" }}>
                Order{" "}
              </span>
              <span className="text-2" style={{ fontWeight: "700" }}>
                {order.deliveryId}
              </span>
              <span className="ml-2">{order.deliveryType}</span>
              <div>
                <span>Invoice {order.invoiceNumber}</span>
              </div>
              <div>{order.route}</div>
              <div>
                <address>
                  <div style={{ fontWeight: "600" }}>{order.customerName}</div>
                  <div>
                    {order.customerAddress} <br />
                    {order.customerCity}, {order.customerState}{" "}
                    {order.customerZip}
                  </div>
                </address>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="col-12 text-2">
                  <br />
                </div>
                <div className="col-md-6">
                  Order Placed {formatDate(order.creationDate)}
                </div>
                <div className="col-md-6">
                  Estimated Delivery {formatDate(order.deliveryDate)}
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="text-right text-2">{order.status}</div>
              <div className="row">
                {/* ******Remember to format currencies, dates, etc, - amount, codamount****** */}
                <div className="col-md-6">
                  {/* Pieces can be other things right? transmission, engine, etc do we have access to the piece type? can we get it? does cxt support pieces and piece types? ********** */}
                  <div>{order.pieceCount} Pieces</div>
                  <div> Amount ${order.amount}</div>
                </div>
                <div className="col-md-6">
                  <div>COD: {order.isCod ? "Yes" : "No"}</div>
                  {order.isCod ? <div>COD Amount ${order.codAmount}</div> : ""}
                </div>
              </div>
            </div>
            <div className="col-md-6 h5">{order.comment}</div>
          </div>
        );
      })}
    </div>
  ) : viewType === "table" ? (
    <div className="table-responsive-sm tabled-bordered">
      <table className="table">
        <thead className="sticky-table-header order-history-results-table-head">
          <tr>
            <th>Order Id</th>
            <th>Invoice Number</th>
            <th>Delivery Date</th>
            <th>Creation Date</th>
            <th>Customer</th>
            <th>Route</th>
            <th>Pieces</th>
            <th>Cod</th>
            <th>Cod Amount</th>
            <th>Delivery Type</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => {
            return (
              <tr>
                <td>{order.deliveryId}</td>
                <td>{order.invoiceNumber}</td>
                <td>{formatDate(order.deliveryDate)}</td>
                <td>{formatDate(order.creationDate)}</td>
                <td>
                  {order.customerName} <br />
                  {order.customerAddress} <br /> {order.customerCity},{" "}
                  {order.customerState} {order.customerZip}
                </td>
                <td>{order.route}</td>
                <td>{order.pieceCount}</td>
                <td>{order.isCod ? "Yes" : "No"}</td>
                <td>{order.codAmount}</td>
                <td>{order.deliveryType}</td>
                <td>{order.status}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  ) : (
    (viewType = "cards" ? <div>cards</div> : null)
  );
};

export default OrderHistoryList;
// (viewType === "table" && <div>table</div>)(
//     viewType === "cards" && <div>cards</div>
//   );
